import { ref, onMounted, onUnmounted } from 'vue';
import { isAppleDevice, isMobile } from '@common/common/utils/utils';

export function useKeyboardDetection() {
    const isKeyboardOpen = ref(false);
    const lastScrollY = ref(0);
    const keyboardHeight = ref(0);

    const trackFocus = (el: HTMLElement | null) => {
        if (!el) return;

        el.addEventListener('focus', () => {
            lastScrollY.value = window.scrollY;
        });
    };

    const detectByViewportResize = () => {
        if (!window.visualViewport) return;

        const windowHeight = window.innerHeight;
        const currentHeight = window.visualViewport.height;
        const heightDiff = windowHeight - currentHeight;

        keyboardHeight.value = heightDiff > 0 ? heightDiff : 0;

        // ✅ 모든 디바이스에서 공통적으로 사용
        isKeyboardOpen.value = keyboardHeight.value > 150;
    };

    const detectByScrollDiff = () => {
        const scrollDiff = Math.abs(window.scrollY - lastScrollY.value);
        if (isAppleDevice() && scrollDiff > 10) {
            isKeyboardOpen.value = true;
        }
    };

    onMounted(() => {
        if (!isMobile()) return;

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', detectByViewportResize);
        } else {
            if (isAppleDevice()) {
                window.addEventListener('scroll', detectByScrollDiff, {
                    passive: true,
                });
            }
        }
    });

    onUnmounted(() => {
        if (!isMobile()) return;

        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', detectByViewportResize);
        } else {
            if (isAppleDevice()) {
                window.removeEventListener('scroll', detectByScrollDiff);
            }
        }
    });

    return {
        isKeyboardOpen,
        keyboardHeight,
        lastScrollY,
        trackFocus,
    };
}
